import { ShortenedUrlState } from './shortened-url-selectors';
import { FAILURE, STARTING, SUCCESS } from '../action/util/action-name-creators';
import {
  Action,
  setStateDirtyByParam,
  updateResourceByObjectKey,
} from '../reducers/utils/state-manager';

const InitialState: ShortenedUrlState = {
  visitDetailsByContactId: {},
  visitDetailsStateByContactId: {},
};

export default (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_SHORTENED_URL_VISITS'): {
      const { contactId } = action.payload.args;
      return updateResourceByObjectKey(state, 'visitDetailsByContactId', contactId, true);
    }
    case SUCCESS('LOAD_SHORTENED_URL_VISITS'): {
      const {
        data,
        args: { contactId },
      } = action.payload;
      return updateResourceByObjectKey(state, 'visitDetailsByContactId', contactId, false, {
        [contactId]: data,
      });
    }
    case FAILURE('LOAD_SHORTENED_URL_VISITS'): {
      const { contactId } = action.payload.args;
      return updateResourceByObjectKey(state, 'visitDetailsByContactId', contactId, false);
    }
    case 'SET_DIRTY_ON_TAB_REGAIN_VISIBILITY': {
      let newState = { ...state };
      const visitDetails = newState.visitDetailsByContactId;
      Object.keys(visitDetails || {}).forEach((contactId) => {
        newState = setStateDirtyByParam(newState, 'visitDetails', 'contactId', contactId);
      });
      return newState;
    }
    default:
      return state;
  }
};
